<template>
<div>
    
</div>
</template>
<script>
export default {
  name: "DriverHelp",
  mounted() {
    window.location.href = "https://driver.digitalpermitbook.com/help/onlinehelp/";
  },
};
</script>